import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ViewerLastPageMutationInput} from '../../graphql/generated/types';

/**
 * 마지막 페이지 저장
 *
 * Origin: pageNicolasApi.lastPage
 * API: POST /api/v1/viewer/last_page
 */
export async function postViewerLastPage(
  {seriesId, productId, rate, spineIndex, isDone}: ViewerLastPageMutationInput,
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/viewer/last_page',
    {
      method: 'POST',
      data: {
        series_id: seriesId,
        product_id: productId,
        rate,
        ...(spineIndex !== undefined && {spine_index: spineIndex}),
        ...(isDone !== undefined && {is_done: isDone}),
      },
    },
    options
  );
  return response.data;
}
